import { useEffect, useState } from "react";
import MultiStepWizardModal from "src/components/Common/UI/MultiStepWizard/MultiStepWizardModal";
import { IStep } from "src/components/Common/UI/MultiStepWizard/Step";
import useMultiStepWizard from "src/components/Common/UI/MultiStepWizard/useMultiStepWizard";
import { initialEstablishmentInterfaceValues } from "./DefaultInterfaceValues";
import EstablishmentUnitIndex from "./wizard/steps/establishmentUnit/EstablishmentUnitIndex";
import EstablishmentNodeIndex from "./wizard/steps/establishmentNode/EstablishmentNodeIndex";
import EstablishmentInterfaceIndex from "./wizard/steps/establishmentInterface/EstablishmentInterfaceIndex";


const SelectInterface = ({
  currentEstablishmentID,
    handleCloseModal,
    initialMode,
    selectedField
  }: CreateEditInterfaceProps) => {

    const [interfaceData, setInterfaceData] = useState<IEstablishmentInterfaceForm>(initialEstablishmentInterfaceValues);

    useEffect(() => {
      setInterfaceData(prevData => ({
        ...prevData,
        establishmentID: currentEstablishmentID !== undefined ? currentEstablishmentID : 0 ,
        selectedField: selectedField !== undefined ? selectedField : "" ,
      }));
    }, [currentEstablishmentID]);

    const updateInterfaceData = (data: Partial<IEstablishmentInterfaceForm>) => {
      setInterfaceData(prevData => ({ ...prevData, ...data }));
    };

    useEffect(() => {
      console.log("interfaceData", interfaceData);
    }, [interfaceData]);

    const { goTo, isActive, mode, deactivateAllSteps, next } = useMultiStepWizard({
      numberOfSteps: 3,
      initialMode: initialMode,
      initialActiveStepIndex: initialMode == "create" ? undefined : -1,
    });
  
    const wizardTitle = initialMode == "create" ? "Επιλογή Interface" : "Επεξεργασία Interface";
    const nextButtonFunctionality = initialMode == "create" ? next : deactivateAllSteps;
    
    const steps: IStep [] = 
    [
      {
        index: 0, 
        isActive: true, 
        stepTitle: "Επιλογή Μονάδας",
        dontHideInactive: true, 
        children: <EstablishmentUnitIndex
          isActive={isActive(0)}
          nextButtonFunction={nextButtonFunctionality}
          index={0}
          toggleEdit={() => goTo(0)}
          mode={mode}
          establishmentID={currentEstablishmentID}
          closeWizard={handleCloseModal}
          updateInterfaceData={updateInterfaceData} 
          interfaceData={interfaceData}        />
      },
      {
        index: 1, 
        isActive: true, 
        stepTitle: "Επιλογή Κόμβου",
        dontHideInactive: true, 
        children: <EstablishmentNodeIndex
          isActive={isActive(1)}
          nextButtonFunction={nextButtonFunctionality}
          index={1}
          toggleEdit={() => goTo(1)}
          mode={mode}
          establishmentID={currentEstablishmentID}
          closeWizard={handleCloseModal}
          updateInterfaceData={updateInterfaceData} 
          interfaceData={interfaceData}        />
      },
      {
        index: 2, 
        isActive: true, 
        stepTitle: "Επιλογή Interface",
        dontHideInactive: true, 
        children: <EstablishmentInterfaceIndex
          isActive={isActive(2)}
          nextButtonFunction={nextButtonFunctionality}
          index={2}
          toggleEdit={() => goTo(2)}
          mode={mode}
          establishmentID={currentEstablishmentID}
          closeWizard={handleCloseModal}
          updateInterfaceData={updateInterfaceData} 
          interfaceData={interfaceData}        />
      },
    ];
    
    return (
      <MultiStepWizardModal 
        closeWizard={handleCloseModal} 
        title={wizardTitle}
        steps={steps}
        isActive={isActive}
      />
    )
  }

export default SelectInterface

interface CreateEditInterfaceProps {
    currentEstablishmentID?: number;
    handleCloseModal: () => void;
    initialMode: "create" | "edit";
    selectedField:string;
  }

